import React, { useState, createContext } from 'react';

const VendorsContext = createContext();

const VendorsProvider = props => {
  const [vendors, setVendors] = useState(VendorsContext);

  // eslint-disable-next-line
  return <VendorsContext.Provider value={[vendors, setVendors]}>{props.children}</VendorsContext.Provider>;
};

export { VendorsContext, VendorsProvider };
